module.exports = __webpack_public_path__ + "static/media/doublemillionaire-unscratched.6ab49b1b.png";